export enum WEB3_EVENT {
  Web3PageView = 'Web3PageView',
  Web3UserClick = 'Web3UserClick',
}

type PageNameSearchTester =
  | string
  | RegExp
  | {
      key: string;
      value: any;
    }
  | ((url: URL) => boolean);

export interface PageViewConfigInfo {
  page_url: string | RegExp | ((url: URL) => boolean);
  page_name:
    | string
    | Record<string, PageNameSearchTester>
    | ((url: URL) => string);
}
